<template>
    <FormSection
        title="Additional Billing Information"
        type="his-section"
        :full-height="false"
        :application-id="application"
    >
        <template #content>
            <section class="row py-3 pb-2 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2"> (HCFA-1500 Form Locators 10A - 10D) Patient's condition related to:</b>
                            </p>
                        </div>
                        <div class="form-check ms-2 pb-1">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="hcfa-patient-employment"
                                v-model="
                                    referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<Employment>k__BackingField'
                                    ]
                                "
                            />
                            <label class="form-check-label" for="hcfa-patient-employment">
                                <small>Employment</small>
                            </label>
                        </div>
                        <div class="form-check ms-2 pb-1">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="hcfa-patient-auto"
                                v-model="
                                    referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<AutoAccident>k__BackingField'
                                    ]
                                "
                            />
                            <label class="form-check-label" for="hcfa-patient-auto">
                                <small>Auto Accident</small>
                            </label>
                        </div>
                        <template
                            v-if="
                                referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<AutoAccident>k__BackingField'
                                ]
                            "
                        >
                            <div class="row ms-3">
                                <div class="form-group col-12 col-lg-5 pe-lg-12 bg-white p-3 m-1">
                                    <label for="hcfa-auto-accident-state"> Select State</label>
                                    <select
                                        class="form-select"
                                        name="hcfa-auto-accident-state"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                                '<AutoAccidentState>k__BackingField'
                                            ]
                                        "
                                    >
                                        <option :value="null">Select Option</option>
                                        <option
                                            v-for="(status, index) in referralOptions?.addressStateCode"
                                            :key="index"
                                            :value="status.value"
                                        >
                                            {{ status.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <div class="form-check ms-2 pb-1">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="hcfa-patient-other"
                                v-model="
                                    referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<OtherAccident>k__BackingField'
                                    ]
                                "
                            />
                            <label class="form-check-label" for="hcfa-patient-other">
                                <small>Other Accident</small>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="px-4 w-100 mt-1">
                    <div class="form-group col-12 col-lg-12 pe-lg-2">
                        <label id="Referral_claim_code" for="referral-claim-code"> Claim Code: </label>
                        <input
                            id="Referral_claim_code"
                            name="referral-claim-code"
                            class="form-control"
                            maxlength="30"
                            placeholder="Enter Code"
                            type="text"
                            v-model="
                                referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<ClaimCodes>k__BackingField'
                                ]
                            "
                        />
                    </div>

                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2">
                                    (HCFA-1500 Form Locator 16) Dates Patient Unable to Work in Current Occupation:</b
                                >
                            </p>
                        </div>
                    </div>

                    <div class="form-group col-12 col-lg-12 pe-lg-12">
                        <label for="patient-unable-from"> Patient Unable to Work From: </label>
                        <DatePicker :getDate="onDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="patient-unable-from"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Date"
                                    autocomplete="off"
                                    :value="
                                        referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<UnableToWorkFrom>k__BackingField'
                                        ]
                                    "
                                    @change="handleDateChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>

                    <div class="form-group col-12 col-lg-12 pe-lg-12">
                        <label for="patient-unable-to"> Patient Unable to Work To: </label>
                        <DatePicker :getDate="onDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="patient-unable-to"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Date"
                                    autocomplete="off"
                                    :value="
                                        referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<UnableToWorkTo>k__BackingField'
                                        ]
                                    "
                                    @change="handleDateChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2">
                                    (HCFA-1500 Form Locator 18) Hospital Dates Related to Current Services:</b
                                >
                            </p>
                        </div>
                    </div>

                    <div class="form-group col-12 col-lg-12 pe-lg-12">
                        <label for="hospitalization-start-date"> Hospitalization Start Date: </label>
                        <DatePicker :getDate="onDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="hospitalization-start-date"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Date"
                                    autocomplete="off"
                                    :value="
                                        referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<HospitalizationBegin>k__BackingField'
                                        ]
                                    "
                                    @change="handleDateChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>

                    <div class="form-group col-12 col-lg-12 pe-lg-12">
                        <label for="hospitalization-end-date"> Hospitalization End Date: </label>
                        <DatePicker :getDate="onDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="hospitalization-end-date"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Date"
                                    autocomplete="off"
                                    :value="
                                        referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<HospitalizationEnd>k__BackingField'
                                        ]
                                    "
                                    @change="handleDateChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>
                    <div class="form-check custom-checkbox ms-2 pb-1">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="hcfa-emergency-treatment"
                            v-model="
                                referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<IsEmergencyIndicatorRequired>k__BackingField'
                                ]
                            "
                        />
                        <label class="form-check-label ms-2" for="hcfa-emergency-treatment">
                            <small>(HCFA-1500 Form Locator 24C) Emergency Treatment Indicator </small>
                        </label>
                    </div>
                </div>
            </section></template
        ></FormSection
    >
</template>

<script lang="ts" src="./AdditionalBillingInfo.ts"></script>
